import React from 'react'
import "./Subtotal.css"
import CurrencyFormat from 'react-currency-format'
import {useDispatch, useSelector} from "react-redux"
import {useHistory} from "react-router-dom"
import {setTotal} from "../redux/totalSlice"

function Subtotal() {
    const dispatch = useDispatch()
    const basket = useSelector(state => state.cart.basket)
    const totalAmount = useSelector(state => state.total.total)
    const history = useHistory()



    React.useEffect(()=>{
        let total = 0;
        for(let i =0; i< basket.length; i++){
            total += basket[i].price
        }
        dispatch(setTotal(total))
    }
    , [basket])


  return (
    <div className='subtotal'>  
        
        <CurrencyFormat 
                renderText={(value)=>(
                        <>
                            <p>
                                Subtotal ({basket.length} items): <strong>${totalAmount.toFixed(2)}</strong>
                            </p>
                            <small className='subtotal-gift'>
                                <input type="checkbox"/> This order contains a gift
                            </small>
                        </>

                )}
            
            decimalScale={2}
            thousandSeparator={true}
            displayType={"text"}
            prefix={"$"}
            
        />
            <button className='subtotal-button' onClick={()=> history.push("/payment")}>Proceed to Checkout</button>
    </div>
  )
}

export default Subtotal